import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { ConditionsSnapshot } from '@/lib/credits-api'

export type SubscriptionConditions = {
  id: string
  package_name: string
  current: ConditionsSnapshot
  pending: ConditionsSnapshot | null
  effective_at: string | null
  is_current: boolean
  catalog: ConditionsSnapshot
  /** A plan change the member confirmed that takes effect at the next billing (downgrade). */
  scheduled_change: { package_name: string; effective_at: string; conditions: ConditionsSnapshot | null } | null
}
export function useSubscriptionConditions(userId?: string, enabled = true) {
  return useQuery({
    enabled,
    queryKey: ['subscription-conditions', userId],
    queryFn: async () => {
      const { data } = userId
        ? await api.GET('/api/v1/users/{id}/subscription-conditions', { params: { path: { id: userId } } })
        : await api.GET('/api/v1/users/me/subscription-conditions')
      return data as unknown as SubscriptionConditions[]
    },
  })
}
